<template>
    <div class="flex-column py-6 px-9 gray-0-bkg prelative">
        <header class="mb-4">
            <p class="fs-6 my-0 lh-reset">{{ $l10n.__('Récapitulatif') }}</p>
            <span class="grey fs-3" v-if="isSale">
                {{ $l10n.__('Envoyé à') }}
                <template v-if="contact.name && contact.forename"
                    >{{ contact.forename }} {{ contact.name }}</template
                >
                <template v-if="contact.email"> - {{ contact.email }}</template>
            </span>
        </header>
        <article>
            <div class="flex-row mb-4" :class="!isSale && isMonthly ? 'ai-center' : 'flex-bottom'">
                <SaasIcon icon="sellsyCloud" width="35" height="24" class="gray-100" />
                <span class="capitalize fs-5 ml-2">{{ licencePlan | lowerCase }}</span>
                <div class="flex-item-right fs-3">
                    <span class="bold">{{ labelPlan }}</span>
                    <span v-if="!isSale && isMonthly" class="fs-2 block aright lh-reset">{{
                        $l10n.__('Engagement 12 mois')
                    }}</span>
                </div>
            </div>
            <slot name="licences"></slot>
        </article>
        <span class="separator block my-3"></span>
        <article class="flex-row jc-space">
            <slot name="subtotal"></slot>
        </article>
        <slot></slot>
        <article class="cart-recap-total">
            <span class="separator block my-3"></span>
            <slot name="total"></slot>
            <slot name="actions"></slot>
        </article>
    </div>
</template>

<script>
import SaasIcon from 'vcomponents/common/SaasIcon.vue';
export default {
    components: {
        SaasIcon,
    },
    props: {
        context: {
            type: String,
            required: true,
            validator: (value) => ['sale', 'client', 'upsell', 'renew', 'pay'].includes(value),
        },
        userSale: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        licencePlan() {
            return this.$store.getters[this.context + 'Cart/currentPlanLabel'];
        },
        contact() {
            return this.$store.getters[this.context + 'Cart/contact'];
        },
        labelPlan() {
            return this.$store.getters[this.context + 'Cart/isYearly']
                ? this.$l10n.__('Abonnement annuel')
                : this.$l10n.__('Abonnement mensuel');
        },
        isSale() {
            return this.userSale;
        },
        isMonthly() {
            return this.$store.getters[this.context + 'Cart/isMonthly'];
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
header > p + span {
    line-height: 20px;
}
.cart .separator {
    height: 1px;
    width: 100%;
    background-color: $gray-40;
}

.cart-recap-total {
    margin-top: auto;
    margin-bottom: 0;
}

.cart-recap-total-label {
    flex-basis: 140px;
}

.cart-action--continue.el-button {
    [class*='el-icon-'] + span {
        margin-left: 0;
    }
}
</style>
